import { GPXFeature } from '@rsos/gainsight';
import { trackSendPreconfiguredMessageClick } from '../textFrom911Trackings';
import { StartMessagesContainer } from './TF911.styles';
import TF911StartMessage from './TF911StartMessage';

interface TF911StartChatMessagesProps {
  isCreatingConversation: boolean;
  preconfiguredMessages: string[];
  onSendMessageClick: (message?: string) => Promise<{ isSuccess: boolean }>;
  isUniteEventPaneEnabled: boolean;
  isForOverview: boolean;
  gpxFeature: GPXFeature;
}

const TF911StartChatMessages = ({
  isCreatingConversation,
  preconfiguredMessages,
  onSendMessageClick,
  isUniteEventPaneEnabled,
  isForOverview,
  gpxFeature,
}: TF911StartChatMessagesProps) => {
  const handleMessageSendClick = (message: string, index: number) => {
    trackSendPreconfiguredMessageClick({
      feature: gpxFeature,
      isUniteEventPaneEnabled,
      fromOverviewTab: isForOverview,
      messageIndex: index,
      message,
    });
    onSendMessageClick(message);
  };

  return (
    <StartMessagesContainer>
      {preconfiguredMessages.map((message, index) => (
        <TF911StartMessage
          key={message}
          isCreatingConversation={isCreatingConversation}
          message={message}
          onSendMessageClick={msg => handleMessageSendClick(msg, index)}
        />
      ))}
    </StartMessagesContainer>
  );
};

export default TF911StartChatMessages;
